import React from 'react';

import {
	Button,	Modal, Space, Title,
} from '@components';

interface DeleteFileModalProps {
	onSubmit: (fileName: string) => void,
	fileName: string,
	closeModal: () => void,
}

function DeleteFileModal(props: DeleteFileModalProps): JSX.Element {
	const {
		fileName,
		closeModal,
		onSubmit,
	} = props;

	return (
		<Modal isOpen>
			<Space alignment="vertical">
				<Title centered>
					Удалить документ?
				</Title>
				<Space alignment="vertical" gap="20px">
					<div>
						После удаления документ не подлежит восстановлению
					</div>
					<Space centered>
						<Button theme="primary" onClick={() => { onSubmit(fileName); closeModal(); }}>
							Удалить
						</Button>
						<Button onClick={closeModal}>
							Отменить
						</Button>
					</Space>
				</Space>
			</Space>
		</Modal>
	);
}

export {DeleteFileModal};